"use strict";
/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * SCILL API
 * SCILL gives you the tools to activate, retain and grow your user base in your app or game by bringing you features well known in the gaming industry: Gamification. We take care of the services and technology involved so you can focus on your game and content.
 *
 * OpenAPI spec version: 1.0.0
 * Contact: support@scillgame.com
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsApi = exports.EventsApiFactory = exports.EventsApiFp = exports.EventsApiFetchParamCreator = exports.ChallengesApi = exports.ChallengesApiFactory = exports.ChallengesApiFp = exports.ChallengesApiFetchParamCreator = exports.BattlePassesApi = exports.BattlePassesApiFactory = exports.BattlePassesApiFp = exports.BattlePassesApiFetchParamCreator = exports.AuthApi = exports.AuthApiFactory = exports.AuthApiFp = exports.AuthApiFetchParamCreator = exports.RequiredError = exports.BaseAPI = exports.COLLECTION_FORMATS = void 0;
var url = require("url");
var portableFetch = require("portable-fetch");
var BASE_PATH = "https://virtserver.swaggerhub.com/4Players-GmbH/scill-gaas/1.0.0".replace(/\/+$/, "");
/**
 *
 * @export
 */
exports.COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
/**
 *
 * @export
 * @class BaseAPI
 */
var BaseAPI = /** @class */ (function () {
    function BaseAPI(configuration, basePath, fetch) {
        if (basePath === void 0) { basePath = BASE_PATH; }
        if (fetch === void 0) { fetch = portableFetch; }
        this.basePath = basePath;
        this.fetch = fetch;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
    return BaseAPI;
}());
exports.BaseAPI = BaseAPI;
;
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
var RequiredError = /** @class */ (function (_super) {
    __extends(RequiredError, _super);
    function RequiredError(field, msg) {
        var _this = _super.call(this, msg) || this;
        _this.field = field;
        return _this;
    }
    return RequiredError;
}(Error));
exports.RequiredError = RequiredError;
/**
 * AuthApi - fetch parameter creator
 * @export
 */
exports.AuthApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get an access token for any user identifier signed with the API-Key
         * @param {ForeignUserIdentifier} body Foreign user identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAccessToken: function (body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling generateAccessToken.');
            }
            var localVarPath = "/api/v1/auth/access-token";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // authentication oAuthNoScopes required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oAuthNoScopes", [""])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("ForeignUserIdentifier" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AuthApi - functional programming interface
 * @export
 */
exports.AuthApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Get an access token for any user identifier signed with the API-Key
         * @param {ForeignUserIdentifier} body Foreign user identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAccessToken: function (body, options) {
            var localVarFetchArgs = exports.AuthApiFetchParamCreator(configuration).generateAccessToken(body, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * AuthApi - factory interface
 * @export
 */
exports.AuthApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Get an access token for any user identifier signed with the API-Key
         * @param {ForeignUserIdentifier} body Foreign user identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAccessToken: function (body, options) {
            return exports.AuthApiFp(configuration).generateAccessToken(body, options)(fetch, basePath);
        },
    };
};
/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
var AuthApi = /** @class */ (function (_super) {
    __extends(AuthApi, _super);
    function AuthApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get an access token for any user identifier signed with the API-Key
     * @param {ForeignUserIdentifier} body Foreign user identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.generateAccessToken = function (body, options) {
        return exports.AuthApiFp(this.configuration).generateAccessToken(body, options)(this.fetch, this.basePath);
    };
    return AuthApi;
}(BaseAPI));
exports.AuthApi = AuthApi;
/**
 * BattlePassesApi - fetch parameter creator
 * @export
 */
exports.BattlePassesApiFetchParamCreator = function (configuration) {
    return {
        /**
         * Activate a given battle pass level by id
         * @summary Activate a given battle pass level by id
         * @param {string} appId The app id
         * @param {string} levelId The id of the battle pass level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateBattlePassLevel: function (appId, levelId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'appId' is not null or undefined
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling activateBattlePassLevel.');
            }
            // verify required parameter 'levelId' is not null or undefined
            if (levelId === null || levelId === undefined) {
                throw new RequiredError('levelId', 'Required parameter levelId was null or undefined when calling activateBattlePassLevel.');
            }
            var localVarPath = "/api/v1/battle-pass-levels/{appId}/activate/{levelId}"
                .replace("{" + "appId" + "}", encodeURIComponent(String(appId)))
                .replace("{" + "levelId" + "}", encodeURIComponent(String(levelId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // authentication oAuthNoScopes required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oAuthNoScopes", [""])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Claim the battle pass level id
         * @summary Claim the battle pass level reward. This will trigger a Webhook that you can use to unlock the reward on server side. If you don't have a server you can also unlock in the client application after receiving a positive response.
         * @param {string} appId The app id
         * @param {string} levelId The id of the battle pass level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimBattlePassLevelReward: function (appId, levelId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'appId' is not null or undefined
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling claimBattlePassLevelReward.');
            }
            // verify required parameter 'levelId' is not null or undefined
            if (levelId === null || levelId === undefined) {
                throw new RequiredError('levelId', 'Required parameter levelId was null or undefined when calling claimBattlePassLevelReward.');
            }
            var localVarPath = "/api/v1/battle-pass-levels/{appId}/claim/{levelId}"
                .replace("{" + "appId" + "}", encodeURIComponent(String(appId)))
                .replace("{" + "levelId" + "}", encodeURIComponent(String(levelId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // authentication oAuthNoScopes required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oAuthNoScopes", [""])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get active battle passes for the app
         * @summary Get battle passes
         * @param {string} appId The app id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveBattlePasses: function (appId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'appId' is not null or undefined
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getActiveBattlePasses.');
            }
            var localVarPath = "/api/v1/battle-passes/{appId}/active"
                .replace("{" + "appId" + "}", encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // authentication oAuthNoScopes required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oAuthNoScopes", [""])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all battle pass levels for an app
         * @summary Get battle pass levels for an app (from all battle passes)
         * @param {string} appId The app id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBattlePassLevels: function (appId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'appId' is not null or undefined
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getAllBattlePassLevels.');
            }
            var localVarPath = "/api/v1/battle-pass-levels/{appId}"
                .replace("{" + "appId" + "}", encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // authentication oAuthNoScopes required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oAuthNoScopes", [""])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get battle pass for the product with id
         * @summary Get battle pass by id
         * @param {string} appId The app id
         * @param {string} battlePassId The id of the battle pass. It’s the same as in battle_pass_id you received in earlier requests (i.e. getting all active battle passes for a product).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBattlePass: function (appId, battlePassId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'appId' is not null or undefined
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getBattlePass.');
            }
            // verify required parameter 'battlePassId' is not null or undefined
            if (battlePassId === null || battlePassId === undefined) {
                throw new RequiredError('battlePassId', 'Required parameter battlePassId was null or undefined when calling getBattlePass.');
            }
            var localVarPath = "/api/v1/battle-passes/{appId}/single/{battlePassId}"
                .replace("{" + "appId" + "}", encodeURIComponent(String(appId)))
                .replace("{" + "battlePassId" + "}", encodeURIComponent(String(battlePassId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // authentication oAuthNoScopes required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oAuthNoScopes", [""])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get battle pass levels for a battle pass
         * @summary Get battle pass levels for a battle pass
         * @param {string} appId The app id
         * @param {string} battlePassId The id of the battle pass. It’s the same as in battle_pass_id you received in earlier requests (i.e. getting all active battle passes for a product).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBattlePassLevels: function (appId, battlePassId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'appId' is not null or undefined
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getBattlePassLevels.');
            }
            // verify required parameter 'battlePassId' is not null or undefined
            if (battlePassId === null || battlePassId === undefined) {
                throw new RequiredError('battlePassId', 'Required parameter battlePassId was null or undefined when calling getBattlePassLevels.');
            }
            var localVarPath = "/api/v1/battle-pass-levels/{appId}/{battlePassId}"
                .replace("{" + "appId" + "}", encodeURIComponent(String(appId)))
                .replace("{" + "battlePassId" + "}", encodeURIComponent(String(battlePassId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // authentication oAuthNoScopes required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oAuthNoScopes", [""])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get battle passes for the product
         * @summary Get battle passes
         * @param {string} appId The app id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBattlePasses: function (appId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'appId' is not null or undefined
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getBattlePasses.');
            }
            var localVarPath = "/api/v1/battle-passes/{appId}"
                .replace("{" + "appId" + "}", encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // authentication oAuthNoScopes required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oAuthNoScopes", [""])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get unlocked battle passes for the user encoded in the access token
         * @summary Get battle passes unlocked by the user
         * @param {string} appId The app id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnlockedBattlePasses: function (appId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'appId' is not null or undefined
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getUnlockedBattlePasses.');
            }
            var localVarPath = "/api/v1/battle-passes/{appId}/unlocked"
                .replace("{" + "appId" + "}", encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // authentication oAuthNoScopes required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oAuthNoScopes", [""])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unlock the battle pass for a user
         * @summary Unlock the battle pass for the user specified in the access token
         * @param {string} appId The app id
         * @param {string} battlePassId The id of the battle pass. It’s the same as in battle_pass_id you received in earlier requests (i.e. getting all active battle passes for a product).
         * @param {BattlePassUnlockPayload} [body] Provide purchase info for the battle pass
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockBattlePass: function (appId, battlePassId, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'appId' is not null or undefined
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling unlockBattlePass.');
            }
            // verify required parameter 'battlePassId' is not null or undefined
            if (battlePassId === null || battlePassId === undefined) {
                throw new RequiredError('battlePassId', 'Required parameter battlePassId was null or undefined when calling unlockBattlePass.');
            }
            var localVarPath = "/api/v1/battle-passes/{appId}/unlock/{battlePassId}"
                .replace("{" + "appId" + "}", encodeURIComponent(String(appId)))
                .replace("{" + "battlePassId" + "}", encodeURIComponent(String(battlePassId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // authentication oAuthNoScopes required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oAuthNoScopes", [""])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("BattlePassUnlockPayload" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BattlePassesApi - functional programming interface
 * @export
 */
exports.BattlePassesApiFp = function (configuration) {
    return {
        /**
         * Activate a given battle pass level by id
         * @summary Activate a given battle pass level by id
         * @param {string} appId The app id
         * @param {string} levelId The id of the battle pass level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateBattlePassLevel: function (appId, levelId, options) {
            var localVarFetchArgs = exports.BattlePassesApiFetchParamCreator(configuration).activateBattlePassLevel(appId, levelId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Claim the battle pass level id
         * @summary Claim the battle pass level reward. This will trigger a Webhook that you can use to unlock the reward on server side. If you don't have a server you can also unlock in the client application after receiving a positive response.
         * @param {string} appId The app id
         * @param {string} levelId The id of the battle pass level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimBattlePassLevelReward: function (appId, levelId, options) {
            var localVarFetchArgs = exports.BattlePassesApiFetchParamCreator(configuration).claimBattlePassLevelReward(appId, levelId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get active battle passes for the app
         * @summary Get battle passes
         * @param {string} appId The app id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveBattlePasses: function (appId, options) {
            var localVarFetchArgs = exports.BattlePassesApiFetchParamCreator(configuration).getActiveBattlePasses(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get all battle pass levels for an app
         * @summary Get battle pass levels for an app (from all battle passes)
         * @param {string} appId The app id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBattlePassLevels: function (appId, options) {
            var localVarFetchArgs = exports.BattlePassesApiFetchParamCreator(configuration).getAllBattlePassLevels(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get battle pass for the product with id
         * @summary Get battle pass by id
         * @param {string} appId The app id
         * @param {string} battlePassId The id of the battle pass. It’s the same as in battle_pass_id you received in earlier requests (i.e. getting all active battle passes for a product).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBattlePass: function (appId, battlePassId, options) {
            var localVarFetchArgs = exports.BattlePassesApiFetchParamCreator(configuration).getBattlePass(appId, battlePassId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get battle pass levels for a battle pass
         * @summary Get battle pass levels for a battle pass
         * @param {string} appId The app id
         * @param {string} battlePassId The id of the battle pass. It’s the same as in battle_pass_id you received in earlier requests (i.e. getting all active battle passes for a product).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBattlePassLevels: function (appId, battlePassId, options) {
            var localVarFetchArgs = exports.BattlePassesApiFetchParamCreator(configuration).getBattlePassLevels(appId, battlePassId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get battle passes for the product
         * @summary Get battle passes
         * @param {string} appId The app id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBattlePasses: function (appId, options) {
            var localVarFetchArgs = exports.BattlePassesApiFetchParamCreator(configuration).getBattlePasses(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get unlocked battle passes for the user encoded in the access token
         * @summary Get battle passes unlocked by the user
         * @param {string} appId The app id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnlockedBattlePasses: function (appId, options) {
            var localVarFetchArgs = exports.BattlePassesApiFetchParamCreator(configuration).getUnlockedBattlePasses(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Unlock the battle pass for a user
         * @summary Unlock the battle pass for the user specified in the access token
         * @param {string} appId The app id
         * @param {string} battlePassId The id of the battle pass. It’s the same as in battle_pass_id you received in earlier requests (i.e. getting all active battle passes for a product).
         * @param {BattlePassUnlockPayload} [body] Provide purchase info for the battle pass
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockBattlePass: function (appId, battlePassId, body, options) {
            var localVarFetchArgs = exports.BattlePassesApiFetchParamCreator(configuration).unlockBattlePass(appId, battlePassId, body, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * BattlePassesApi - factory interface
 * @export
 */
exports.BattlePassesApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         * Activate a given battle pass level by id
         * @summary Activate a given battle pass level by id
         * @param {string} appId The app id
         * @param {string} levelId The id of the battle pass level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateBattlePassLevel: function (appId, levelId, options) {
            return exports.BattlePassesApiFp(configuration).activateBattlePassLevel(appId, levelId, options)(fetch, basePath);
        },
        /**
         * Claim the battle pass level id
         * @summary Claim the battle pass level reward. This will trigger a Webhook that you can use to unlock the reward on server side. If you don't have a server you can also unlock in the client application after receiving a positive response.
         * @param {string} appId The app id
         * @param {string} levelId The id of the battle pass level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimBattlePassLevelReward: function (appId, levelId, options) {
            return exports.BattlePassesApiFp(configuration).claimBattlePassLevelReward(appId, levelId, options)(fetch, basePath);
        },
        /**
         * Get active battle passes for the app
         * @summary Get battle passes
         * @param {string} appId The app id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveBattlePasses: function (appId, options) {
            return exports.BattlePassesApiFp(configuration).getActiveBattlePasses(appId, options)(fetch, basePath);
        },
        /**
         * Get all battle pass levels for an app
         * @summary Get battle pass levels for an app (from all battle passes)
         * @param {string} appId The app id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBattlePassLevels: function (appId, options) {
            return exports.BattlePassesApiFp(configuration).getAllBattlePassLevels(appId, options)(fetch, basePath);
        },
        /**
         * Get battle pass for the product with id
         * @summary Get battle pass by id
         * @param {string} appId The app id
         * @param {string} battlePassId The id of the battle pass. It’s the same as in battle_pass_id you received in earlier requests (i.e. getting all active battle passes for a product).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBattlePass: function (appId, battlePassId, options) {
            return exports.BattlePassesApiFp(configuration).getBattlePass(appId, battlePassId, options)(fetch, basePath);
        },
        /**
         * Get battle pass levels for a battle pass
         * @summary Get battle pass levels for a battle pass
         * @param {string} appId The app id
         * @param {string} battlePassId The id of the battle pass. It’s the same as in battle_pass_id you received in earlier requests (i.e. getting all active battle passes for a product).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBattlePassLevels: function (appId, battlePassId, options) {
            return exports.BattlePassesApiFp(configuration).getBattlePassLevels(appId, battlePassId, options)(fetch, basePath);
        },
        /**
         * Get battle passes for the product
         * @summary Get battle passes
         * @param {string} appId The app id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBattlePasses: function (appId, options) {
            return exports.BattlePassesApiFp(configuration).getBattlePasses(appId, options)(fetch, basePath);
        },
        /**
         * Get unlocked battle passes for the user encoded in the access token
         * @summary Get battle passes unlocked by the user
         * @param {string} appId The app id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnlockedBattlePasses: function (appId, options) {
            return exports.BattlePassesApiFp(configuration).getUnlockedBattlePasses(appId, options)(fetch, basePath);
        },
        /**
         * Unlock the battle pass for a user
         * @summary Unlock the battle pass for the user specified in the access token
         * @param {string} appId The app id
         * @param {string} battlePassId The id of the battle pass. It’s the same as in battle_pass_id you received in earlier requests (i.e. getting all active battle passes for a product).
         * @param {BattlePassUnlockPayload} [body] Provide purchase info for the battle pass
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockBattlePass: function (appId, battlePassId, body, options) {
            return exports.BattlePassesApiFp(configuration).unlockBattlePass(appId, battlePassId, body, options)(fetch, basePath);
        },
    };
};
/**
 * BattlePassesApi - object-oriented interface
 * @export
 * @class BattlePassesApi
 * @extends {BaseAPI}
 */
var BattlePassesApi = /** @class */ (function (_super) {
    __extends(BattlePassesApi, _super);
    function BattlePassesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Activate a given battle pass level by id
     * @summary Activate a given battle pass level by id
     * @param {string} appId The app id
     * @param {string} levelId The id of the battle pass level.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BattlePassesApi
     */
    BattlePassesApi.prototype.activateBattlePassLevel = function (appId, levelId, options) {
        return exports.BattlePassesApiFp(this.configuration).activateBattlePassLevel(appId, levelId, options)(this.fetch, this.basePath);
    };
    /**
     * Claim the battle pass level id
     * @summary Claim the battle pass level reward. This will trigger a Webhook that you can use to unlock the reward on server side. If you don't have a server you can also unlock in the client application after receiving a positive response.
     * @param {string} appId The app id
     * @param {string} levelId The id of the battle pass level.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BattlePassesApi
     */
    BattlePassesApi.prototype.claimBattlePassLevelReward = function (appId, levelId, options) {
        return exports.BattlePassesApiFp(this.configuration).claimBattlePassLevelReward(appId, levelId, options)(this.fetch, this.basePath);
    };
    /**
     * Get active battle passes for the app
     * @summary Get battle passes
     * @param {string} appId The app id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BattlePassesApi
     */
    BattlePassesApi.prototype.getActiveBattlePasses = function (appId, options) {
        return exports.BattlePassesApiFp(this.configuration).getActiveBattlePasses(appId, options)(this.fetch, this.basePath);
    };
    /**
     * Get all battle pass levels for an app
     * @summary Get battle pass levels for an app (from all battle passes)
     * @param {string} appId The app id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BattlePassesApi
     */
    BattlePassesApi.prototype.getAllBattlePassLevels = function (appId, options) {
        return exports.BattlePassesApiFp(this.configuration).getAllBattlePassLevels(appId, options)(this.fetch, this.basePath);
    };
    /**
     * Get battle pass for the product with id
     * @summary Get battle pass by id
     * @param {string} appId The app id
     * @param {string} battlePassId The id of the battle pass. It’s the same as in battle_pass_id you received in earlier requests (i.e. getting all active battle passes for a product).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BattlePassesApi
     */
    BattlePassesApi.prototype.getBattlePass = function (appId, battlePassId, options) {
        return exports.BattlePassesApiFp(this.configuration).getBattlePass(appId, battlePassId, options)(this.fetch, this.basePath);
    };
    /**
     * Get battle pass levels for a battle pass
     * @summary Get battle pass levels for a battle pass
     * @param {string} appId The app id
     * @param {string} battlePassId The id of the battle pass. It’s the same as in battle_pass_id you received in earlier requests (i.e. getting all active battle passes for a product).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BattlePassesApi
     */
    BattlePassesApi.prototype.getBattlePassLevels = function (appId, battlePassId, options) {
        return exports.BattlePassesApiFp(this.configuration).getBattlePassLevels(appId, battlePassId, options)(this.fetch, this.basePath);
    };
    /**
     * Get battle passes for the product
     * @summary Get battle passes
     * @param {string} appId The app id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BattlePassesApi
     */
    BattlePassesApi.prototype.getBattlePasses = function (appId, options) {
        return exports.BattlePassesApiFp(this.configuration).getBattlePasses(appId, options)(this.fetch, this.basePath);
    };
    /**
     * Get unlocked battle passes for the user encoded in the access token
     * @summary Get battle passes unlocked by the user
     * @param {string} appId The app id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BattlePassesApi
     */
    BattlePassesApi.prototype.getUnlockedBattlePasses = function (appId, options) {
        return exports.BattlePassesApiFp(this.configuration).getUnlockedBattlePasses(appId, options)(this.fetch, this.basePath);
    };
    /**
     * Unlock the battle pass for a user
     * @summary Unlock the battle pass for the user specified in the access token
     * @param {string} appId The app id
     * @param {string} battlePassId The id of the battle pass. It’s the same as in battle_pass_id you received in earlier requests (i.e. getting all active battle passes for a product).
     * @param {BattlePassUnlockPayload} [body] Provide purchase info for the battle pass
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BattlePassesApi
     */
    BattlePassesApi.prototype.unlockBattlePass = function (appId, battlePassId, body, options) {
        return exports.BattlePassesApiFp(this.configuration).unlockBattlePass(appId, battlePassId, body, options)(this.fetch, this.basePath);
    };
    return BattlePassesApi;
}(BaseAPI));
exports.BattlePassesApi = BattlePassesApi;
/**
 * ChallengesApi - fetch parameter creator
 * @export
 */
exports.ChallengesApiFetchParamCreator = function (configuration) {
    return {
        /**
         * Activate a personal challenge by product id and user challenge id
         * @summary Activate a personal challenges
         * @param {string} appId The app id
         * @param {string} challengeId The challenge id (see challenge_id of Challenge object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activatePersonalChallenge: function (appId, challengeId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'appId' is not null or undefined
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling activatePersonalChallenge.');
            }
            // verify required parameter 'challengeId' is not null or undefined
            if (challengeId === null || challengeId === undefined) {
                throw new RequiredError('challengeId', 'Required parameter challengeId was null or undefined when calling activatePersonalChallenge.');
            }
            var localVarPath = "/api/v1/challenges/personal/activate/{appId}/{challengeId}"
                .replace("{" + "appId" + "}", encodeURIComponent(String(appId)))
                .replace("{" + "challengeId" + "}", encodeURIComponent(String(challengeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // authentication oAuthNoScopes required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oAuthNoScopes", [""])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel an active personal challenge by product id and user challenge id
         * @summary Cancel an active personal challenges
         * @param {string} appId The app id
         * @param {string} challengeId The challenge id (see challenge_id of Challenge object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPersonalChallenge: function (appId, challengeId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'appId' is not null or undefined
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling cancelPersonalChallenge.');
            }
            // verify required parameter 'challengeId' is not null or undefined
            if (challengeId === null || challengeId === undefined) {
                throw new RequiredError('challengeId', 'Required parameter challengeId was null or undefined when calling cancelPersonalChallenge.');
            }
            var localVarPath = "/api/v1/challenges/personal/cancel/{appId}/{challengeId}"
                .replace("{" + "appId" + "}", encodeURIComponent(String(appId)))
                .replace("{" + "challengeId" + "}", encodeURIComponent(String(challengeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // authentication oAuthNoScopes required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oAuthNoScopes", [""])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Claim the reward of a finished personal challenge by product id and user challenge id
         * @summary Claim the reward of a finished personal challenge
         * @param {string} appId The app id
         * @param {string} challengeId The challenge id (see challenge_id of Challenge object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimPersonalChallengeReward: function (appId, challengeId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'appId' is not null or undefined
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling claimPersonalChallengeReward.');
            }
            // verify required parameter 'challengeId' is not null or undefined
            if (challengeId === null || challengeId === undefined) {
                throw new RequiredError('challengeId', 'Required parameter challengeId was null or undefined when calling claimPersonalChallengeReward.');
            }
            var localVarPath = "/api/v1/challenges/personal/claim/{appId}/{challengeId}"
                .replace("{" + "appId" + "}", encodeURIComponent(String(appId)))
                .replace("{" + "challengeId" + "}", encodeURIComponent(String(challengeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // authentication oAuthNoScopes required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oAuthNoScopes", [""])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an access token for the Websockets server notifying of updates in real time
         * @summary Get an access token for the Websockets server notifying of updates in real time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWebsocketAccessToken: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/challenges/web-socket/generate-token";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // authentication oAuthNoScopes required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oAuthNoScopes", [""])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get active personal challenges organized in categories
         * @summary Get active personal challenges
         * @param {string} appId The app id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivePersonalChallenges: function (appId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'appId' is not null or undefined
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getActivePersonalChallenges.');
            }
            var localVarPath = "/api/v1/challenges/personal/get-in-progress-challenges/{appId}"
                .replace("{" + "appId" + "}", encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // authentication oAuthNoScopes required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oAuthNoScopes", [""])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get personal challenges organized in categories
         * @summary Get personal challenges
         * @param {string} appId The app id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonalChallenges: function (appId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'appId' is not null or undefined
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getPersonalChallenges.');
            }
            var localVarPath = "/api/v1/challenges/personal/get/{appId}"
                .replace("{" + "appId" + "}", encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // authentication oAuthNoScopes required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oAuthNoScopes", [""])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unlock a personal challenge by product id and challenge id
         * @summary Unlock a personal challenges
         * @param {string} appId The app id
         * @param {string} challengeId The challenge id (see challenge_id of Challenge object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockPersonalChallenge: function (appId, challengeId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'appId' is not null or undefined
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling unlockPersonalChallenge.');
            }
            // verify required parameter 'challengeId' is not null or undefined
            if (challengeId === null || challengeId === undefined) {
                throw new RequiredError('challengeId', 'Required parameter challengeId was null or undefined when calling unlockPersonalChallenge.');
            }
            var localVarPath = "/api/v1/challenges/personal/unlock/{appId}/{challengeId}"
                .replace("{" + "appId" + "}", encodeURIComponent(String(appId)))
                .replace("{" + "challengeId" + "}", encodeURIComponent(String(challengeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication BearerAuth required
            // authentication oAuthNoScopes required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oAuthNoScopes", [""])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ChallengesApi - functional programming interface
 * @export
 */
exports.ChallengesApiFp = function (configuration) {
    return {
        /**
         * Activate a personal challenge by product id and user challenge id
         * @summary Activate a personal challenges
         * @param {string} appId The app id
         * @param {string} challengeId The challenge id (see challenge_id of Challenge object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activatePersonalChallenge: function (appId, challengeId, options) {
            var localVarFetchArgs = exports.ChallengesApiFetchParamCreator(configuration).activatePersonalChallenge(appId, challengeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Cancel an active personal challenge by product id and user challenge id
         * @summary Cancel an active personal challenges
         * @param {string} appId The app id
         * @param {string} challengeId The challenge id (see challenge_id of Challenge object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPersonalChallenge: function (appId, challengeId, options) {
            var localVarFetchArgs = exports.ChallengesApiFetchParamCreator(configuration).cancelPersonalChallenge(appId, challengeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Claim the reward of a finished personal challenge by product id and user challenge id
         * @summary Claim the reward of a finished personal challenge
         * @param {string} appId The app id
         * @param {string} challengeId The challenge id (see challenge_id of Challenge object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimPersonalChallengeReward: function (appId, challengeId, options) {
            var localVarFetchArgs = exports.ChallengesApiFetchParamCreator(configuration).claimPersonalChallengeReward(appId, challengeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get an access token for the Websockets server notifying of updates in real time
         * @summary Get an access token for the Websockets server notifying of updates in real time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWebsocketAccessToken: function (options) {
            var localVarFetchArgs = exports.ChallengesApiFetchParamCreator(configuration).generateWebsocketAccessToken(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get active personal challenges organized in categories
         * @summary Get active personal challenges
         * @param {string} appId The app id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivePersonalChallenges: function (appId, options) {
            var localVarFetchArgs = exports.ChallengesApiFetchParamCreator(configuration).getActivePersonalChallenges(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get personal challenges organized in categories
         * @summary Get personal challenges
         * @param {string} appId The app id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonalChallenges: function (appId, options) {
            var localVarFetchArgs = exports.ChallengesApiFetchParamCreator(configuration).getPersonalChallenges(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Unlock a personal challenge by product id and challenge id
         * @summary Unlock a personal challenges
         * @param {string} appId The app id
         * @param {string} challengeId The challenge id (see challenge_id of Challenge object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockPersonalChallenge: function (appId, challengeId, options) {
            var localVarFetchArgs = exports.ChallengesApiFetchParamCreator(configuration).unlockPersonalChallenge(appId, challengeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * ChallengesApi - factory interface
 * @export
 */
exports.ChallengesApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         * Activate a personal challenge by product id and user challenge id
         * @summary Activate a personal challenges
         * @param {string} appId The app id
         * @param {string} challengeId The challenge id (see challenge_id of Challenge object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activatePersonalChallenge: function (appId, challengeId, options) {
            return exports.ChallengesApiFp(configuration).activatePersonalChallenge(appId, challengeId, options)(fetch, basePath);
        },
        /**
         * Cancel an active personal challenge by product id and user challenge id
         * @summary Cancel an active personal challenges
         * @param {string} appId The app id
         * @param {string} challengeId The challenge id (see challenge_id of Challenge object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPersonalChallenge: function (appId, challengeId, options) {
            return exports.ChallengesApiFp(configuration).cancelPersonalChallenge(appId, challengeId, options)(fetch, basePath);
        },
        /**
         * Claim the reward of a finished personal challenge by product id and user challenge id
         * @summary Claim the reward of a finished personal challenge
         * @param {string} appId The app id
         * @param {string} challengeId The challenge id (see challenge_id of Challenge object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimPersonalChallengeReward: function (appId, challengeId, options) {
            return exports.ChallengesApiFp(configuration).claimPersonalChallengeReward(appId, challengeId, options)(fetch, basePath);
        },
        /**
         * Get an access token for the Websockets server notifying of updates in real time
         * @summary Get an access token for the Websockets server notifying of updates in real time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWebsocketAccessToken: function (options) {
            return exports.ChallengesApiFp(configuration).generateWebsocketAccessToken(options)(fetch, basePath);
        },
        /**
         * Get active personal challenges organized in categories
         * @summary Get active personal challenges
         * @param {string} appId The app id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivePersonalChallenges: function (appId, options) {
            return exports.ChallengesApiFp(configuration).getActivePersonalChallenges(appId, options)(fetch, basePath);
        },
        /**
         * Get personal challenges organized in categories
         * @summary Get personal challenges
         * @param {string} appId The app id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonalChallenges: function (appId, options) {
            return exports.ChallengesApiFp(configuration).getPersonalChallenges(appId, options)(fetch, basePath);
        },
        /**
         * Unlock a personal challenge by product id and challenge id
         * @summary Unlock a personal challenges
         * @param {string} appId The app id
         * @param {string} challengeId The challenge id (see challenge_id of Challenge object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockPersonalChallenge: function (appId, challengeId, options) {
            return exports.ChallengesApiFp(configuration).unlockPersonalChallenge(appId, challengeId, options)(fetch, basePath);
        },
    };
};
/**
 * ChallengesApi - object-oriented interface
 * @export
 * @class ChallengesApi
 * @extends {BaseAPI}
 */
var ChallengesApi = /** @class */ (function (_super) {
    __extends(ChallengesApi, _super);
    function ChallengesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Activate a personal challenge by product id and user challenge id
     * @summary Activate a personal challenges
     * @param {string} appId The app id
     * @param {string} challengeId The challenge id (see challenge_id of Challenge object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApi
     */
    ChallengesApi.prototype.activatePersonalChallenge = function (appId, challengeId, options) {
        return exports.ChallengesApiFp(this.configuration).activatePersonalChallenge(appId, challengeId, options)(this.fetch, this.basePath);
    };
    /**
     * Cancel an active personal challenge by product id and user challenge id
     * @summary Cancel an active personal challenges
     * @param {string} appId The app id
     * @param {string} challengeId The challenge id (see challenge_id of Challenge object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApi
     */
    ChallengesApi.prototype.cancelPersonalChallenge = function (appId, challengeId, options) {
        return exports.ChallengesApiFp(this.configuration).cancelPersonalChallenge(appId, challengeId, options)(this.fetch, this.basePath);
    };
    /**
     * Claim the reward of a finished personal challenge by product id and user challenge id
     * @summary Claim the reward of a finished personal challenge
     * @param {string} appId The app id
     * @param {string} challengeId The challenge id (see challenge_id of Challenge object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApi
     */
    ChallengesApi.prototype.claimPersonalChallengeReward = function (appId, challengeId, options) {
        return exports.ChallengesApiFp(this.configuration).claimPersonalChallengeReward(appId, challengeId, options)(this.fetch, this.basePath);
    };
    /**
     * Get an access token for the Websockets server notifying of updates in real time
     * @summary Get an access token for the Websockets server notifying of updates in real time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApi
     */
    ChallengesApi.prototype.generateWebsocketAccessToken = function (options) {
        return exports.ChallengesApiFp(this.configuration).generateWebsocketAccessToken(options)(this.fetch, this.basePath);
    };
    /**
     * Get active personal challenges organized in categories
     * @summary Get active personal challenges
     * @param {string} appId The app id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApi
     */
    ChallengesApi.prototype.getActivePersonalChallenges = function (appId, options) {
        return exports.ChallengesApiFp(this.configuration).getActivePersonalChallenges(appId, options)(this.fetch, this.basePath);
    };
    /**
     * Get personal challenges organized in categories
     * @summary Get personal challenges
     * @param {string} appId The app id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApi
     */
    ChallengesApi.prototype.getPersonalChallenges = function (appId, options) {
        return exports.ChallengesApiFp(this.configuration).getPersonalChallenges(appId, options)(this.fetch, this.basePath);
    };
    /**
     * Unlock a personal challenge by product id and challenge id
     * @summary Unlock a personal challenges
     * @param {string} appId The app id
     * @param {string} challengeId The challenge id (see challenge_id of Challenge object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApi
     */
    ChallengesApi.prototype.unlockPersonalChallenge = function (appId, challengeId, options) {
        return exports.ChallengesApiFp(this.configuration).unlockPersonalChallenge(appId, challengeId, options)(this.fetch, this.basePath);
    };
    return ChallengesApi;
}(BaseAPI));
exports.ChallengesApi = ChallengesApi;
/**
 * EventsApi - fetch parameter creator
 * @export
 */
exports.EventsApiFetchParamCreator = function (configuration) {
    return {
        /**
         * Post an event to the SCILL backend
         * @summary Post an event
         * @param {EventPayload} body Event payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEvent: function (body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling sendEvent.');
            }
            var localVarPath = "/api/v1/events";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication ApiKeyType required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("auth")
                    : configuration.apiKey;
                localVarQueryParameter["auth"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // authentication oAuthNoScopes required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oAuthNoScopes", [""])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("EventPayload" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EventsApi - functional programming interface
 * @export
 */
exports.EventsApiFp = function (configuration) {
    return {
        /**
         * Post an event to the SCILL backend
         * @summary Post an event
         * @param {EventPayload} body Event payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEvent: function (body, options) {
            var localVarFetchArgs = exports.EventsApiFetchParamCreator(configuration).sendEvent(body, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * EventsApi - factory interface
 * @export
 */
exports.EventsApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         * Post an event to the SCILL backend
         * @summary Post an event
         * @param {EventPayload} body Event payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEvent: function (body, options) {
            return exports.EventsApiFp(configuration).sendEvent(body, options)(fetch, basePath);
        },
    };
};
/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
var EventsApi = /** @class */ (function (_super) {
    __extends(EventsApi, _super);
    function EventsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Post an event to the SCILL backend
     * @summary Post an event
     * @param {EventPayload} body Event payload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    EventsApi.prototype.sendEvent = function (body, options) {
        return exports.EventsApiFp(this.configuration).sendEvent(body, options)(this.fetch, this.basePath);
    };
    return EventsApi;
}(BaseAPI));
exports.EventsApi = EventsApi;



//////////////////
// WEBPACK FOOTER
// ./~/@scillgame/scill-js/dist/api.js
// module id = 134
// module chunks = 0